const CF7selectElements = document.querySelectorAll('.wpcf7-select');

CF7selectElements?.forEach((select) => {
  if (select.options[select.selectedIndex].value === '') {
    select.classList.add('empty-selected');
  }

  select.addEventListener('change', () => {
    if (select.options[select.selectedIndex].value === '') {
      select.classList.add('empty-selected');
    } else {
      select.classList.remove('empty-selected');
    }
  });
});

const carrouselFormations = new Swiper('.carrousel-formations', {
  slidesPerView: 1,
  spaceBetween: 25,
  navigation: {
    nextEl: '.carrousel-formations-next',
    prevEl: '.carrousel-formations-prev',
  },
  keyboard: true,
  breakpoints: {
    540: {
      slidesPerView: 2,
    },
    800: {
      slidesPerView: 3,
    },
  },
});

const filterLinks = document.querySelectorAll(
  '.carrousel-formations__filters > li > a'
);
const slides = document.querySelectorAll('.swiper-slide');

// Function to handle the click event on filter links
function handleClick(event) {
  event.preventDefault(); // Prevent the native link behavior

  const selectedId = this.getAttribute('data-niveau');

  // Loop through all the slides to apply the filter
  slides.forEach((slide) => {
    const slideNiveaux = slide.getAttribute('data-niveaux');
    if (
      selectedId === 'all' ||
      !slideNiveaux ||
      slideNiveaux.split(', ').includes(selectedId)
    ) {
      slide.style.display = 'block'; // Show the slide if it matches the selected filter or "all"
    } else {
      slide.style.display = 'none'; // Hide the slide if it doesn't match the selected filter
    }
  });

  // Toggle 'data-selected' attribute for the clicked item
  filterLinks.forEach((link) => {
    if (link !== this) {
      link.removeAttribute('data-selected');
    }
  });

  if (!this.hasAttribute('data-selected')) {
    this.setAttribute('data-selected', 'true');
  }

  // Update the Swiper instance to reflect the changes
  carrouselFormations.update();
  carrouselFormations.slideTo(0); // Reset the carousel to the first slide
}

// Add click event listener to each filter link
filterLinks.forEach((link) => {
  link.addEventListener('click', handleClick);
});

// Simulate a click on the "Toutes" link to show all formations by default
const allLink = document.querySelector('[data-niveau="all"]');
if (allLink) {
  allLink.click();
}

const carrouselArticles = new Swiper('.carrousel-articles', {
  slidesPerView: 1,
  spaceBetween: 25,
  navigation: {
    nextEl: '.carrousel-articles-next',
    prevEl: '.carrousel-articles-prev',
  },
  keyboard: true,
  breakpoints: {
    540: {
      slidesPerView: 2,
    },
    800: {
      slidesPerView: 3,
    },
  },
});

const carrouselTemoignagesLarge = new Swiper('.carrousel-temoignages-large', {
  slidesPerView: 1,
  navigation: {
    nextEl: '.carrousel-temoignages-large-next',
    prevEl: '.carrousel-temoignages-large-prev',
  },
  loop: true,
  keyboard: true,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
});

const carrouselTemoignages = new Swiper('.carrousel-temoignages', {
  slidesPerView: 1,
  navigation: {
    nextEl: '.carrousel-temoignages-next',
    prevEl: '.carrousel-temoignages-prev',
  },
  loop: true,
  keyboard: true,
  autoHeight: true,
});

const carrouselEquipeSmallElements = document.querySelectorAll(
  '.carrousel-equipe-small'
);

carrouselEquipeSmallElements.forEach((element) => {
  const container = element.closest('.carrousel-equipe-small__container'); // Find the parent container
  if (container) {
    new Swiper(element, {
      slidesPerView: 1,
      navigation: {
        nextEl: container.querySelector('.carrousel-equipe-small-next'), // Find next button in parent container
        prevEl: container.querySelector('.carrousel-equipe-small-prev'), // Find prev button in parent container
      },
      keyboard: true,
      autoHeight: true,
    });
  }
});

const iconClasses = [
  'skilzhicon-skp_1',
  'skilzhicon-skp_2',
  'skilzhicon-skp_3',
  'skilzhicon-skp_4',
  'skilzhicon-skp_5',
  'skilzhicon-skp_6',
  'skilzhicon-skp_7',
  'skilzhicon-skp_8',
];

const h2Elements = document.querySelectorAll(
  '.content-style h2:not(.colonnes-bordures h2):not(.front-page h2)'
);

h2Elements.forEach((h2, index) => {
  h2.classList.add(iconClasses[index % iconClasses.length]);
});

const videosYoutubeContainer = document.querySelectorAll(
  '.wp-block-embed__wrapper'
);

videosYoutubeContainer.forEach((item) => {
  item.classList.add('plyr__video-embed');
  new Plyr(item, {
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
      'mute',
      'volume',
      'fullscreen',
    ],
  });
});
